import React from 'react';
import RedirectSessionSearchOrPartnerSearch from './RedirectSessionSearchOrPartnerSearch';

const RedirectSessionSearch = (...props) => <RedirectSessionSearchOrPartnerSearch isSessionSearch={true} {...props} />;

export default RedirectSessionSearch;
